import {AppManagerContext} from "./Contexts";
import {useContext} from "react";

export function useManager() {
    return useContext(AppManagerContext);
}
